import React from 'react';
import HanoiGame from './HanoiGame';

function App() {
  return (
    <div className="App">
<HanoiGame />
    </div>
  );
}

export default App;
